import dayjs from 'dayjs'
import { qcopy, isHighGlu, isLowGlu, isNormalGlu, findObjIndexInArray, padZero, trimEndZero } from '@u'
import { derror, error } from '@u/log'
import { _getPumpBasalFromRecords } from './reportHelper'

const _cache = { // 血糖,y轴值范围0->20,10等分; 如果单位是mg,那么y轴值范围是0->360,需要修改下面的ymax
  isUnitMmol: true, // 如果是false,意味着血糖单位是mg,那么ymax从20变成360(乘以18)
  ymin: 0, // 改变ymin或ymax,要相应改变下面的yranges
  ymax: 20, // 改变ymin或ymax,要相应改变下面的yranges
  count: 10, // 高度10等分,3个range
  ranges: [[0, 3], [3, 15], [15, 20.0001]],
  _rangesWidth: [1, 8, 1], // 分别占据1/10, 8/10,1/10
}
_cache.rangesWidth = _getRangesWidth()
_cache.yranges = _getYRanges()
// const yranges = 
// console.error(`bg helper yranges: ${yranges}`) // dev,test,mock

export function _transferBGData(v, isUnitMg = false) { // 需要修改;y轴0->20;如果单位是mg,那么y轴值范围是0->360
  // console.error(`[_transferBGData]入参v: ${v}, isUnitMg: ${isUnitMg}, _cache: `, {
  //   ..._cache
  // })
  // 首先确保单位正确
  _switchBGUnit(isUnitMg ? 1 : 0)
  
  const { ranges, ymin, ymax, count, _rangesWidth, rangesWidth, yranges } = _cache
  const origin = +v
  const max = ranges[ranges.length - 1][1] // 20
  const min = ranges[0][0] // 0
  let rst = origin

  if (Number.isNaN(origin)) {
    console.error(`[_transferBGData]柱形图转换数据,输入的数据是非法数字v: ${v};为了逻辑不崩，直接return v`)
    return v
  }
  
  const i = _whatRangeIndex(origin)
  if (i < 0) {
    if (origin - min < 0) {
      console.error(`[_transferBGData]数据v: ${v},不再范围 ${min}~${max}之间`)
      return origin
    }
    if (origin - max > 0) {
      console.error(`[_transferBGData]数据v: ${v},不再范围 ${min}~${max}之间`)
      return origin
    }
  } else {
    const rs = ranges[i]
    const rsGap = rs[1] - rs[0]
    const rw = rangesWidth[i]
    const min = rs[0]
    
    const gap = origin - min
    
    rst = +yranges[i] + (gap / rsGap) * rw
    rst = +((+rst).toFixed(1))

    // console.error(`[_transferBGData]入参v: ${v},rst: ${rst}, isUnitMg: ${isUnitMg}, _whatRangeIndex: ${i}, _cache`, {
    //   _cache: { ..._cache }
    // })
  }
  return rst
}

export function _transferYHeightToBGValue(y, isUnitMg = false) { // 需要修改;y轴0->20;如果单位是mg,那么y轴值范围是0->360;然后y轴高度h，对应的血糖值应该是多少
  try {
    // 首先确保单位正确
    _switchBGUnit(isUnitMg ? 1 : 0)
    // console.error(`[_transferHeightToBGValue]入参y: ${y}, isUnitMg: ${isUnitMg}, _cache: `, {
    //   ..._cache
    // })

    const { yranges, ymax, ymin, _rangesWidth, ranges } = _cache
    const yH = ymax - ymin

    if (y - ymax >= 0 || y - ymin <= 0) {
      console.error(`[_transferHeightToBGValue]数据y: ${y},不再范围 yranges: ${yranges}范围内`)
      return y
    }
    
    const i = _whatRangeWidthIndex(y)

    if (i < 0) {
      console.error(`[_transferHeightToBGValue]数据y: ${y},不再范围 yranges: ${yranges}范围内`)
      return y
    }

    const whatRanges = ranges[i] // y轴的范围(0->20或者0->360)

    const rangeGap = whatRanges[1] - whatRanges[0]
    const ybreakpoint = yranges[i]
    const yrangesGap = yranges[i + 1] - ybreakpoint
    const yGapInRange = y - ybreakpoint
    const yGapInRangeRatio = yGapInRange / yrangesGap
    const yGap = yGapInRangeRatio * rangeGap
    const rst = yGap + whatRanges[0]
    return rst
  } catch (error) {
    console.error('被捕获:' + error)
    // debugger
    return 0
  }
}

function _getRangesWidth() {
  try {
    const { ymin, ymax, count, ranges, _rangesWidth } = _cache
    const _rangesWidthSum = _rangesWidth.reduce((prev, cur) => {
      return cur + prev
    }, 0)
    const rangesWidth = _rangesWidth.map(v => ymax * v / _rangesWidthSum)
    return rangesWidth
  } catch (error) {
    console.error('被捕获:' + error)
    return []
  }
}

function _getYRanges() {
  try {
    const { rangesWidth, ymax, ymin = 0 } = _cache
    const rangesWidthSum = rangesWidth.reduce((prev, cur) => {
      return cur + prev
    }, 0)

    const rst = rangesWidth.map((v, i) => {
      if (i === 0) {
        return ymin
      } else {
        const l = rangesWidth.length
        const rest = l - i - 1
        
        let sumAfterIIncludingI = 0      
        for (let j = 0; j <= rest; j++) {
          sumAfterIIncludingI += (rangesWidth[j + i])
        }
        
        return rangesWidthSum - sumAfterIIncludingI + ymin
      }
    })

    rst.push(ymax) // 推入最后一个最大值ymax
    return rst
  } catch (error) {
    console.error('被捕获:' + error)
    return []
  }
}

function _whatRangeIndex(v) {
  const { ranges } = _cache
  let index = -1
  ranges.forEach((range, i) => {
    const min = range[0]
    const max = range[1]
    if (v - min >= 0 && v - max < 0) {
      index = i
    }
  })
  return index
}

function _whatRangeWidthIndex(h) {
  const { yranges } = _cache

  let index = -1
  for (let i = 0; i < yranges.length; i++) {
    const next = yranges[i + 1]
    const limit = yranges[i]
    if (next !== undefined) {
      if (h - limit > 0 && h - next <= 0) {
        index = i
        break
      }
    } else {
      index = i
      break
    }    
  }
  return index
}

function _switchBGUnit(unit = 0) {
  const currentCacheUnitIsNotMg = !!_cache.isUnitMmol
  let isUnitMg = false
  const ratio = 18 // mmol变成mg需要乘以ratio
  const alittle = 0.00001

  /* eslint-disable */
  switch (+unit) {
  case 1: // mg
    isUnitMg = true
    break
  case 0:
  default:
    break
  }
  /* eslint-enable */
  // console.error(`[_transferBGData]ssssssssssssssssssssssssssssss _switchBGUnit, unit: ${unit}, 需要变成unitMg: ${isUnitMg}, 目前是否是unitMg: ${!currentCacheUnitIsNotMg}`)

  if (isUnitMg) {
    // 想切成mg
    if (currentCacheUnitIsNotMg) {
      // 需要切成mg
      const isUnitMmol = false
      const ymin = _cache.ymin * ratio
      const ymax = _cache.ymax * ratio
      const ranges = _cache.ranges.map((range, i) => {
        const [min, max] = range
        if (i + 1 >= _cache.ranges.length) {
          // 最后一个
          return [min * ratio, ymax + alittle]
        } else {
          return [min * ratio, max * ratio]
        }
      })

      Object.assign(_cache, {
        isUnitMmol, ymin, ymax, ranges
      })

      _cache.rangesWidth = _getRangesWidth() // 一定要更新_cache后再计算新的rangesWidth
      _cache.yranges = _getYRanges() // 一定要更新_cache后再计算新的yranges
    }
  } else {
    // 想切成mmol
    if (!currentCacheUnitIsNotMg) { // 现在是mg,需要切成mmol
      const isUnitMmol = true
      const ymin = _cache.ymin / ratio
      const ymax = _cache.ymax / ratio
      const ranges = _cache.ranges.map((range, i) => {
        const [min, max] = range
        if (i + 1 >= _cache.ranges.length) {
          // 最后一个
          return [ymin, ymax + alittle]
        } else {
          return [min / ratio, max / ratio]
        }
      })

      Object.assign(_cache, {
        isUnitMmol, ymin, ymax, ranges
      })
      
      _cache.rangesWidth = _getRangesWidth() // 一定要更新_cache后再计算新的rangesWidth
      _cache.yranges = _getYRanges() // 一定要更新_cache后再计算新的yranges      
    }
  }
}
